<template>
    <div>
        <!-- Home Section -->
        <section id="home">
            <section id="xslider" class="contain">
                <div class="txp-banner">
                    <img :src="baseUrl + '/new-assets/images/banner.jpg'" alt="slidebg1" data-bgfit="cover"
                        data-bgposition="left top" data-bgrepeat="no-repeat" style="width: 100%" />
                </div>
            </section>
        </section>
        <!-- End Home Section -->

        <section id="Survey" class="contain ">
            <div class="inner">
                <div class="header margin-10px-bottom">
                    <span>Feedback Survey</span>
                </div>
                <form action="">
                    <div class="survey-box">
                        <div id="q1" class="survey">
                            <div class="q">1) How did you find the Venue?</div>
                            <div class="as">
                                <input type="radio" id="q1-a1" name="q1">
                                <label for="q1-a1" class="a">Excellent</label>

                                <input type="radio" id="q1-a2" name="q1">
                                <label for="q1-a2" class="a">Good</label>

                                <input type="radio" id="q1-a3" name="q1">
                                <label for="q1-a3" class="a">Fair</label>

                                <input type="radio" id="q1-a4" name="q1">
                                <label for="q1-a4" class="a">Poor</label>
                            </div>
                        </div>
                        <div id="q2" class="survey">
                            <div class="q">5) Were there any challenges you encountered while registering for or attending
                                this event?</div>
                            <div class="as">
                                <input type="radio" id="q2-a1" name="q2">
                                <label for="q2-a1" class="a">Yes</label>

                                <input type="radio" id="q2-a2" name="q2">
                                <label for="q2-a2" class="a">NO</label>

                                <input type="radio" id="q2-a3" name="q2">
                                <label for="q2-a3" class="a">If Yes, please let us know the issues you face</label>
                            </div>
                        </div>
                        <div id="q3" class="survey">
                            <div class="q">8) Do you want to share other comments or suggestions with us?</div>
                            <div class="as">
                                <textarea></textarea>
                            </div>
                        </div>
                        <button type="submit"> Submit </button>
                    </div>
                </form>
            </div>
            <!-- End inner div -->
        </section>
    </div>
</template>

<script>
export default {
    data: () => ({
        baseUrl: window.location.origin,
    }),
}
</script>

<style></style>